<template>
  <Button
    ref="refButtonDetails"
    v-if="visibleButton"
    icon="pi pi-bell"
    :severity="notice"
    rounded
    aria-label="Notification"
    class="details-development__button"
    @click="visibleSidebar = true"
  />
  <Sidebar
    v-model:visible="visibleSidebar"
    position="bottom"
    style="height: 90vh"
  >
    <template v-for="(valueInfo, indexValueInfo) in info" :key="indexValueInfo">
      <h4>{{ valueInfo.title }}</h4>
      <template
        v-for="(valueObservation, indexObservation) in valueInfo.observation"
        :key="indexObservation"
      >
        <b>{{ valueObservation.label }}:</b>
        <pre v-if="typeof valueObservation.text === 'object'" class="mb-0">
        {{ valueObservation.text }}
        </pre>
        <p v-else v-html="valueObservation.text" class="mb-1" />
      </template>
      <DataTable
        v-if="valueInfo.values"
        stripedRows
        :value="valueInfo.values"
        class="p-datatable-sm"
      >
        <Column
          v-for="(valueColumn, valueColumnIndex) in valueInfo.columns"
          :key="valueColumnIndex"
          :field="valueColumn.field"
          :header="valueColumn.header"
        ></Column>
      </DataTable>
      <br />
    </template>
  </Sidebar>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  ComponentPublicInstance,
  PropType,
} from "vue";
import { useStore } from "vuex";

interface IColumns {
  field: string;
  header: string;
}

interface IValues {
  [prop: string]: string | number;
}

interface IObservation {
  label: string;
  text: string;
}

interface IInfo {
  title: string;
  columns?: IColumns[];
  values?: IValues[];
  observation?: IObservation[];
}

export default defineComponent({
  props: {
    info: {
      type: Array as PropType<IInfo[]>,
      default: () => [],
    },
    notice: {
      type: String as PropType<"info" | "warning" | "danger">,
      default: "info",
    },
  },

  setup(props) {
    const store = useStore();
    const visibleButton = computed(() => {
      addStyleParent();

      return store.getters["user/showDetailsDevelopment"];
    });
    const visibleSidebar = ref(false);
    const refButtonDetails = ref<ComponentPublicInstance<HTMLButtonElement>>();
    const dictionaryColors = {
      info: "rgb(2, 122, 188)",
      warning: "rgb(251, 192, 45)",
      danger: "rgb(211, 47, 47)",
    };

    const addStyleParent = () => {
      if (refButtonDetails.value) {
        const position =
          refButtonDetails.value.$el.parentElement.style.position;
        const boxShadow =
          refButtonDetails.value.$el.parentElement.style.boxShadow;
        const colorSelected = `${
          dictionaryColors[props.notice]
        } 0px 0px 0px 2px`;

        refButtonDetails.value.$el.parentElement.style.position =
          position !== "relative" ? "relative" : null;
        refButtonDetails.value.$el.parentElement.style.boxShadow =
          boxShadow !== colorSelected ? colorSelected : null;
      }
    };

    return { visibleSidebar, visibleButton, refButtonDetails };
  },
});
</script>

<style lang="scss" scoped>
.details-development {
  &__button {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1003;
  }
}
</style>
